<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SY6bn7/tc-custom/9781504067447.jpg?1701235094048" alt="This image is the cover for the book Starfarers Series Books 1–2, The Starfarers Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Starfarers Series Books 1–2, The Starfarers Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The first two books in “the most important series in science fiction” from the <i>New York Times</i>–bestselling author of <i>Dreamsnake</i> (Ursula K. Le Guin, author of the Earthsea series).</b><br/>  <br/><b><i>Starfarers</i></b><br/>  <br/> The <i>Starfarer</i> is a self-sufficient spaceship with a functioning ecosystem, able to navigate from one star system to another via cosmic string, and it is about to embark on a deep space expedition in search of alien contact. Its global crew has come together in the spirit of cooperation and scientific advancement. But Earth struggles with anti-science and anti-technology factions, and there are those who want to turn the <i>Starfarer</i> into a military base. One of them is on board. And he will stop at nothing—including sabotage—to enforce his agenda . . .<br/>  <br/><b><i>Transition</i></b><br/>  <br/> After the crew members of the <i>Starfarer</i> hijack their own ship, they intercept an alien message and attempt to decipher its complex patterns. It could be an introduction, a warning, or a trap. In Tau Ceti, the first star system humans have ever visited, they discover worlds possessing life but no higher forms of intelligence. And with a saboteur still in their midst, tensions rise as the ship and its team hurtle toward a meeting more than three millennia in the making . . .<br/>  <br/><b>Praise for the Starfarers Series</b><br/>  <br/> “McIntyre is a master SF stylist, creating well-rounded, believable and distinctive characters, and she excels at lush descriptions that allow the reader to visualize the action.” —<i>Publishers Weekly</i><br/>  <br/> “The series features a diverse cast, especially for its 1989 debut date, and a series of interstellar hijinks, the likes of which only McIntyre could conjure.” —Tor.com<br/>  <br/> “A fine novel of adventure.” —Greg Bear on <i>Starfarers</i><br/>  <br/> “The most exciting and satisfying science fiction I have read this year.” —Ursula K. Le Guin on <i>Metaphase</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vonda N. McIntyre
      </h2>
      
      <p class="authorDescription body article">Vonda N.&#160;McIntyre (1948&ndash;2019) was the award-winning science fiction and fantasy author of <I>Dreamsnake</I>,&#160;<I>The King&rsquo;s Daughter </I>(<I>The Moon and the Sun</I>), and many other highly praised novels and short stories. McIntyre&rsquo;s books and short fiction won Hugo and Nebula Awards, and her <I>Star Trek</I> and <I>Star Wars</I> tie-ins are beloved by generations of fans. McIntyre founded Clarion West, a writing workshop for speculative fiction writers, and was a founding member of the Book View Caf&eacute;, an author-owned publishing cooperative. A quiet, tireless feminist, she nurtured hundreds of writers. Through her writing, teaching, and works, McIntyre both shaped and nurtured the science fiction/fantasy community.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4124de6c